import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState, useEffect } from "react";
import ConfirmButton from "../../Shared/Buttons/ConfirmButton";
import InlineAlert from "../../Shared/InlineAlert";
import { useTranslation } from "react-i18next";

export default function TeacherAreaModal({ isOpen, onConfirm, options, loadingOptions, language }) {
  const { t, i18n } = useTranslation();
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [alert, setAlert] = useState({});

  useEffect(() => {
    if (language) i18n.changeLanguage(language);
  }, [language, i18n]);

  useEffect(() => {
    if (isOpen) {
      setSelectedAreas([]);
      setAlert({});
    }
  }, [isOpen]);

  const handleChange = (value) => {
    setSelectedAreas((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleConfirm = () => {
    if (selectedAreas.length === 0) {
      setAlert({ type: "error", message: "Selecione pelo menos uma área de atuação." });
      return;
    }
    setAlert({});
    onConfirm && onConfirm(selectedAreas);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {}}
        static
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full flex flex-col max-w-[500px] transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg leading-6 font-dosisbold text-center">
                  Antes de começarmos, informe qual a sua área de atuação:
                </Dialog.Title>
                <div className="flex flex-col px-6 py-6 gap-3">
                  <InlineAlert
                    alert={alert}
                    visible={alert.type === "error"}
                  />

                  <div className="flex flex-col gap-4 items-start">
                    {loadingOptions ? (
                      <span>Carregando áreas...</span>
                    ) : options?.length > 0 ? (
                      options.map((opt) => (
                        <label key={opt.id} className="flex items-center gap-2 text-base">
                          <input
                            type="checkbox"
                            checked={selectedAreas.includes(opt.id)}
                            onChange={() => handleChange(opt.id)}
                            className="w-5 h-5 accent-blue-500 rounded border-gray-300"
                          />
                          {opt.name}
                        </label>
                      ))
                    ) : (
                      <span>Nenhuma área encontrada.</span>
                    )}
                  </div>

                  <div className="mt-6 flex justify-center">
                    <ConfirmButton onClick={handleConfirm} disabled={selectedAreas.length === 0 || loadingOptions} className={"w-64"} />
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}